/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import sensorLineSettingsTemplate from './sensor-line-settings.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.sensorLineSettings', [])
    .directive('agSensorLineSettings', SensorLineSettings)
    .name;

/*@ngInject*/
function SensorLineSettings() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            sensorLine: '=',
            silo: '<'
        },
        controller: SensorLineSettingsController,
        controllerAs: 'vm',
        templateUrl: sensorLineSettingsTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SensorLineSettingsController($scope, agDeviceService, agTypes) {

    let vm = this;
    vm.agTypes = agTypes;

    let positionsCalculated = false;

    watchPositions();

    function watchPositions() {
        $scope.positionsWatch = $scope.$watch('vm.sensorLine.positionX + vm.sensorLine.positionY + vm.sensorLine.positionZ', function() {
            if (vm.silo.siloType == agTypes.siloType.cylinder) {
                if (positionsCalculated) {
                    positionsCalculated = false;
                    return;
                }
                if (vm.sensorLine) {
                    let x =0, y=0, z=0;
                    if (angular.isDefined(vm.sensorLine.positionX) && vm.sensorLine.positionX != null) {
                        x = vm.sensorLine.positionX;
                    }
                    if (angular.isDefined(vm.sensorLine.positionY) && vm.sensorLine.positionY != null) {
                        y = vm.sensorLine.positionY;
                    }
                    if (angular.isDefined(vm.sensorLine.positionZ) && vm.sensorLine.positionZ != null) {
                        z = vm.sensorLine.positionZ;
                    }
                    vm.height = z;
                    vm.radius = round(Math.sqrt(x*x+y*y));
                    let radians = Math.atan2(y,x);
                    if (radians < 0) {
                        radians += 2 * Math.PI;
                    }
                    vm.angle = round(radians * 180 / Math.PI);
                }
            }
        });
    }

    function round(value) {
        return parseFloat((value).toFixed(13));
    }

    $scope.calculatePositions = () => {
        if (vm.sensorLine) {
            let angle = 0;
            let radius = 0;
            let height = 0;
            if (angular.isDefined(vm.angle) && vm.angle != null) {
                angle = vm.angle;
            }
            if (angular.isDefined(vm.radius) && vm.radius != null) {
                radius = vm.radius;
            }
            if (angular.isDefined(vm.height) && vm.height != null) {
                height = vm.height;
            }
            if (angle >= 180) {
                angle -= 360;
            }
            let angleRads = (angle * Math.PI) / 180;
            vm.sensorLine.positionX = radius * Math.cos(angleRads);
            vm.sensorLine.positionY = radius * Math.sin(angleRads);
            vm.sensorLine.positionZ = height;
            positionsCalculated = true;
            agDeviceService.saveDevice(vm.sensorLine).then(function success() {});
        }
    }

    $scope.calculateBuildingPositions = () => {
        if (vm.sensorLine) {
            agDeviceService.saveDevice(vm.sensorLine).then(function success() {});
        }
    }
}
